import BetSlipInfoItem from 'Components/BetSlip/Footer/BetSlipInfoItem';
import { Button } from 'Components/Button';
import ToastTemplate from 'Components/ToastTemplate';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { openDrawer } from 'Store/actions';
import {
  MULTIPLE_COUPON_BUTTON_VISIBLE,
  MULTIPLE_COUPON_BUTTON_VISIBLE_LIVE,
  MULTIPLE_COUPON_COUNT_MAX_VALUE_LIVE,
  MULTIPLE_COUPON_COUNT_MIN_VALUE
} from 'Store/constants';
import getMaxTotalOdd from 'Utils/getMaxTotalOdd';
import History from 'Store/history';

import { doubleDigitDecimalFormatter, decimalFormatter } from 'Utils/decimalFormatter';
import EnvironmentManager from 'Utils/environmentManager';
import inputMinMaxValidator from 'Utils/inputMinMaxValidator';

import BetSlipCounts from './BetSlipCounts';
import BetSlipSettingsContent from './BetSlipSettingsContent';
import Icon from 'Components/Icon';
import classnames from 'classnames';

class Footer extends Component {
  static propTypes = {
    coupon: PropTypes.object,
    validatedCoupon: PropTypes.object,
    isMBSValid: PropTypes.bool,
    isMBSCombinationValid: PropTypes.bool,
    toggleBetSlipOddsChange: PropTypes.func,
    onPlayClick: PropTypes.func,
    isPlaying: PropTypes.bool,
    isVisibleSuperSystemButton: PropTypes.bool,
    setBetSlipMultiplier: PropTypes.func,
    setBetSlipCouponCount: PropTypes.func,
    setBetSlipSystem: PropTypes.func,
    openModal: PropTypes.func,
    getSystemCoupons: PropTypes.func,
    history: PropTypes.object,
    toggleBetSlip: PropTypes.func,
    userAgent: PropTypes.object,
    saveCoupon: PropTypes.func,
    auth: PropTypes.object,
    isSettingsOpen: PropTypes.bool,
    openDrawer: PropTypes.func,
    betSlipData: PropTypes.object,
  };

  constructor (props) {
    super(props);

    this.state = {
      isLive: false,
      multiplier: props.coupon.multiplier,
      couponCount: props.coupon.couponCount || MULTIPLE_COUPON_COUNT_MIN_VALUE,
      isDesktop: this.props.userAgent?.device?.type === 'desktop',
      showCounts: false,
      activeInputId: '',
      isUpdateButtonDisabled: true,
      settings: {
        acceptHigherOdds: this.props.auth?.data?.acceptHigherOdds,
        acceptLowerOdds: this.props.auth?.data?.acceptLowerOdds,
        acceptLiveEvents: this.props.auth?.data?.acceptLiveEvents,
        acceptPrematchEvents: this.props.auth?.data?.acceptPrematchEvents,
      }
    };

    this.betSlipContent = document.querySelector('.betslip__content');
  }

  componentDidMount () {
    const { coupon } = this.props;

    document.addEventListener('mousedown', this.onMouseDown);
    window.visualViewport?.addEventListener('resize', this.updateKeyboardHeight);
    window.visualViewport?.addEventListener('scroll', this.updateKeyboardHeight);

    this.setState({
      isLive: coupon.bets.length && coupon.bets.every(bet => bet.isLive)
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.coupon.bets.length !== this.props.coupon.bets.length) {
      const isLive = this.props.coupon.bets.length && this.props.coupon.bets.every(bet => bet.isLive);

      if (isLive && this.props.coupon.couponCount > MULTIPLE_COUPON_COUNT_MAX_VALUE_LIVE) {
        this.setState({
          couponCount: MULTIPLE_COUPON_COUNT_MAX_VALUE_LIVE
        });
      }

      this.setState({
        isLive
      });
    }

    if (prevProps.coupon.multiplier !== this.props.coupon.multiplier) {
      this.setState({
        multiplier: this.props.coupon.multiplier
      });
    }

    if (prevProps.coupon.couponCount !== this.props.coupon.couponCount) {
      this.setState({
        couponCount: this.props.coupon.couponCount
      });
    }
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.onMouseDown);
    window.visualViewport?.removeEventListener('resize', this.updateKeyboardHeight);
    window.visualViewport?.removeEventListener('scroll', this.updateKeyboardHeight);
    document.documentElement.style.removeProperty('--betslip-keyboard-height');
  }

  onMouseDown = e => {
    this.lastClickedElement = e.target;
  };

  onClick = e => {
    e.preventDefault();

    const { id } = e.currentTarget;

    if (this.state.isDesktop || (id === 'couponCount' && this.props.coupon.canPlayMultipleCoupons === false)) return;

    this.setState({
      showCounts: true,
      activeInputId: id,
    });

    if (this.betSlipContent) {
      this.betSlipContent.style.height = 'calc(100% - 100px)';
    }
  };

  onCountsFinish = () => {
    this.setState({
      showCounts: false,
      activeInputId: ''
    });

    if (this.betSlipContent) {
      this.betSlipContent.style.height = '';
    }

    document.documentElement.style.removeProperty('--betslip-keyboard-height');
  };

  onChange = e => {
    const numberRegex = /^[0-9\b]+$/;
    const isValid = e.target.value !== '' ? numberRegex.test(e.target.value) : true;
    const { id, value } = e.target;

    if (isValid) {
      this.setState({
        [id]: value
      });

      if (!this.state.isDesktop) {
        if (id === 'multiplier') {
          this.props.setBetSlipMultiplier(value);
        } else {
          this.props.setBetSlipCouponCount(value);
        }
      }
    }
  };

  onBlur = async e => {
    const { id, value } = e.target;
    const { coupon, coupon: { bets } } = this.props;

    const clickedElement = e.relatedTarget || this.lastClickedElement || document.activeElement;

    const playBtnEl = clickedElement?.closest?.('[data-role="play-button"]');
    const iconBtnEl = clickedElement?.closest?.('[data-role="bet-icon"]');

    if (+coupon[id] === +this.state[id]) {
      return this.setState({
        [id]: +this.state[id],
      });
    }

    const modifiedValue = inputMinMaxValidator({
      id,
      value,
      isLive: this.state.isLive,
      system: coupon.system,
      betCount: bets.length
    });

    this.setState({
      [id]: modifiedValue.value,
    });

    if (id === 'multiplier') {
      await this.props.setBetSlipMultiplier(modifiedValue.value, true);
    } else {
      await this.props.setBetSlipCouponCount(+modifiedValue.value, true);
    }

    const targetEl = playBtnEl || iconBtnEl || clickedElement;
    const isDisabled
      = !!targetEl?.classList?.contains('bly-disabled')
      || targetEl?.disabled === true
      || targetEl?.getAttribute?.('disabled') !== null;

    if ((playBtnEl || iconBtnEl) && !isDisabled && typeof targetEl?.click === 'function') {
      targetEl.click();
    }
  };


  onFocus = e => {
    e.target.value = '';
  };

  calculateTotalOdds = couponDetails => {
    let totalOdds = 1;

    couponDetails.forEach(coupon => {
      const bet = coupon?.bets?.[0];
      if (!bet) return;
      const topWinOdd = bet.topWinOdds ? parseFloat(bet.topWinOdds) : null;
      const odd = parseFloat(bet.odd);

      totalOdds *= topWinOdd || odd;
    });

    return totalOdds;
  };

  updateKeyboardHeight = () => {
    if (!window.visualViewport) return;

    const keyboardHeight
      = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;

    document.documentElement.style.setProperty(
      '--betslip-keyboard-height',
      `${Math.max(0, keyboardHeight)}px`
    );
  };

  render () {
    const {
      coupon,
      validatedCoupon,
      isMBSValid,
      auth,
      isMBSCombinationValid,
      betSlipData
    } = this.props;

    const { iddaaTopWinResponse } = validatedCoupon || {};

    const isPlayButtonCanDisable
      = EnvironmentManager.getMessageText({ key: 'betslip_play_save_button_passive' }) === 'true' || false;

    const systemValueDigitNumber = coupon.system.join('');
    const systemValueText = systemValueDigitNumber.length > 4
      ? `${coupon.system.slice(0, 2).join(',')}...`
      : coupon.system.join(',');

    const isHtw = coupon.bets.length && coupon.bets.some(bet => bet.topWinOdds);
    const isLive = coupon.bets.length && coupon.bets.every(bet => bet.isLive);

    const showButton = isLive
      ? MULTIPLE_COUPON_BUTTON_VISIBLE_LIVE !== false
      : MULTIPLE_COUPON_BUTTON_VISIBLE !== false;

    const { couponDetails = [], validateData = {} } = betSlipData || {};
    const isSystemCoupon = (validateData?.data?.columnCount || 0) > 1;
    const wsBettingStatus = couponDetails.filter(e => e.wsBettingStatus);

    const showTopWin = isHtw && !isSystemCoupon;

    // eslint-disable-next-line no-nested-ternary
    const totalOddHtwValue = showTopWin
      ? (
        isMBSValid && iddaaTopWinResponse?.hasTopWin
          ? doubleDigitDecimalFormatter(iddaaTopWinResponse?.totalOddsWithTopWin)
          : doubleDigitDecimalFormatter(Math.min(this.calculateTotalOdds(couponDetails), getMaxTotalOdd()))
      )
      : null;

    const maxWinHtwValue = showTopWin
      ? `${
        isMBSValid && iddaaTopWinResponse?.hasTopWin
          ? decimalFormatter(iddaaTopWinResponse?.expectedTotalWinAmountWithTopWin)
          : decimalFormatter(this.calculateTotalOdds(couponDetails) * this.state.multiplier)
      } TL`
      : null;

    const totalOddValue = doubleDigitDecimalFormatter(coupon.totalOdd);
    const maxWinValue = `${decimalFormatter(coupon.expectedWinAmount)} TL`;

    const saveIconArea = wsBettingStatus.length === 0 && coupon.bets.length ? (
      <i
        className={
          isPlayButtonCanDisable && (coupon.bets.length < 1 || !isMBSValid || !isMBSCombinationValid)
            ? 'bly bly-save-stroke bly-size22 bly-disabled betslip__header__save'
            : 'bly bly-save-stroke bly-size22 betslip__header__save'
        }
        data-role="bet-icon"
        onClick={ () => {
          if (!(isPlayButtonCanDisable && (coupon.bets.length < 1 || !isMBSValid || !isMBSCombinationValid))) {
            if (!isMBSValid) {
              return toast(
                <ToastTemplate type="error">
                  MBS kuralı nedeniyle kuponuna maç eklemeye devam etmelisin.
                </ToastTemplate>,
                {
                  toastId: 'betSlipMbsToast'
                }
              );
            }

            if (auth.isAuthenticated) {
              this.props.openModal('savedCouponNameModal');
            } else {
              History.push('/giris-yap');
            }
          }
        } }
      />
    ) : null;

    const deleteIconArea = coupon.bets.length > 0 && (
      <i
        className="bly bly-bin bly-size22 betslip__header__delete"
        data-role="bet-icon"
        onClick={ () => this.props.openModal('deleteCouponPermissionModal') }
      />
    );

    const settingsIconArea = auth.isAuthenticated ? (
      <i
        className="bly bly-gear bly-size22 betslip__header__settings"
        data-role="bet-icon"
        onClick={ () => {
          if (auth.isAuthenticated) {
            this.props.openDrawer({
              isOpen: true,
              title: EnvironmentManager.getMessageText({ key: 'betslip_settings_title' }) || 'Ayarlar',
              className: 'betslip-settings-drawer',
              showCloseOnBottom: true,
              content: <BetSlipSettingsContent />,
              container: document.getElementsByClassName('betslip')[0],
              position: { web: 'bottom', mobile: 'bottom' },
            });
          } else {
            History.push('/giris-yap');
          }
        } }
      />
    ) : null;

    if (this.state.showCounts) {
      return (
        <div className={ classnames({
          betslip__footer__fixed: true,
          'betslip__footer__fixed--keyboard': this.state.activeInputId === 'multiplier'
        }) }>
          <BetSlipCounts
            isLive={ this.state.isLive }
            inputId={ this.state.activeInputId }
            couponCount={ this.state.couponCount }
            multiplier={ this.state.multiplier }
            cost={ coupon.couponCost }
            system={ coupon.system }
            betCount={ coupon.bets.length }
            onChange={ this.onChange }
            onFinish={ this.onCountsFinish }
          />
        </div>
      );
    }

    return (
      <div className="betslip__footer__fixed">
        <div className="betslip__footer">
          <div className="betslip__footer__bottom">
            <div className="betslip__footer__bottom__utils">
              { settingsIconArea }
              { deleteIconArea }
              { saveIconArea }
            </div>

            <Button
              title="HEMEN OYNA"
              data-role="play-button"
              className="btn--primary betslip__footer__bottom__play-button"
              onClick={ this.props.onPlayClick }
              disabled={ this.props.isPlaying || (isPlayButtonCanDisable && (coupon.bets.length < 1 || !isMBSValid || !isMBSCombinationValid)) }
            >
              HEMEN OYNA
            </Button>
          </div>

          <div className="betslip__footer__selections">
            <BetSlipInfoItem
              label="Kupon Bedeli"
              value={ `${decimalFormatter(coupon.couponCost)} TL` }
            />

            <BetSlipInfoItem
              id="multiplier"
              label="Misli"
              inputMaxLength={ 5 }
              value={ this.state.multiplier }
              type={ this.state.isDesktop ? 'input' : 'clickable' }
              onClick={ this.onClick }
              onFocus={ this.onFocus }
              onBlur={ this.onBlur }
              onChange={ this.onChange }
            />


            <BetSlipInfoItem
              label="Toplam Oran"
              htwValue={ totalOddHtwValue }
              value={ totalOddValue }
            />

            <BetSlipInfoItem
              label="Sistem"
              value={ systemValueText }
              type={ this.state.isDesktop ? 'input' : 'clickable' }
              onClick={ e => {
                e.preventDefault();

                if (validatedCoupon.isValid && isMBSValid) {
                  this.props.openModal('selectSystemModal');
                }
              } }
            />

            <BetSlipInfoItem
              label="Maks. Kazanç"
              htwValue={ maxWinHtwValue }
              value={ maxWinValue }
              isMaxWin
            />

            { showButton && (
              <BetSlipInfoItem
                id="couponCount"
                label="Çoklu Kupon"
                value={ this.state.couponCount }
                type={ this.state.isDesktop ? 'input' : 'clickable' }
                onClick={ this.onClick }
                inputMaxLength={ 5 }
                onFocus={ this.onFocus }
                onBlur={ this.onBlur }
                onChange={ this.onChange }
                disabled={ this.props.coupon.canPlayMultipleCoupons === false }
                labelIcon={
                  <Icon
                    className="betslip__footer__selections__info-item__label-icon"
                    iconName="svgInfo"
                  />
                }
                onLabelClick={ e => {
                  e.preventDefault();
                  this.props.openModal('betSlipLabelInfoModal');
                } }
              />
            ) }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  {
    openDrawer,
  }
)(Footer);
